import React from 'react'
import ScreenDateTabs from './ScreenDateTabs'
import { Box } from '@mui/material'

const ScreenShots = () => {
  return (
    <div>
      <ScreenDateTabs />
    </div>
  )
}

export default ScreenShots
